import { createSlice } from "@reduxjs/toolkit";
import { UserRole } from "types/users";
import { fetchRoles } from "./thunk";

export interface Roles {
    items: UserRole[],
    loading: boolean,
    error: string | null,
    last_fetched_at: number|null
}

const initialState: Roles = {
    items: [],
    loading: false,
    error: null,
    last_fetched_at: null
}

const roles = createSlice({
    name: 'roles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchRoles.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchRoles.fulfilled, (state, action) => {
            state.items = action.payload;
            state.last_fetched_at = Date.now();
            state.error = null;
            state.loading = false;
        })
        .addCase(fetchRoles.rejected, (state, action) => {
            state.error = action.payload ?? 'Failed to fetch roles';
            state.loading = false;
        })
    }
})

export default roles.reducer;